import React from 'react';
import { Link } from 'react-router-dom';
import { CatalogItem, categoryMeta } from '../../data/catalog';
interface CatalogTableProps {
  rows: CatalogItem[];
  caption: string;
  variant?: 'overview' | 'category' | 'inserts';
}
const th = 'border-r border-white/10 px-4 py-3 text-left font-mono text-[10px] font-medium tracking-label text-aluminum last:border-r-0';
const td = 'border-r border-rule px-4 py-3.5 align-top last:border-r-0';
export function CatalogTable({
  rows,
  caption,
  variant = 'category'
}: CatalogTableProps) {
  const showCategory = variant === 'overview';
  const showSpecs = variant === 'inserts';
  return <div data-id="element-512" data-mp="3eop8bpayr2jv">
      {/* md and up: semantic table */}
      <div className="hidden border border-rule bg-white md:block" data-id="element-513" data-mp="3ipix0kw8cldt">
        <table className="w-full border-collapse" data-id="element-514" data-mp="3irv9wjn4s5k0">
          <caption className="sr-only" data-id="element-515" data-mp="3npwuxa44aey4">{caption}</caption>
          <thead data-id="element-516" data-mp="3nn0zbsfqs2cu">
            <tr className="bg-navy" data-id="element-517" data-mp="3snovesitv9dx">
              <th scope="col" className={`${th} w-[190px]`} data-id="element-518" data-mp="3soq6uy3r9xw6">
                PART NUMBER
              </th>
              {showSpecs ? <>
                  <th scope="col" className={`${th} w-[90px]`} data-id="element-519" data-mp="39zafr9z1ttjo">
                    GRADE
                  </th>
                  <th scope="col" className={`${th} w-[120px]`} data-id="element-520" data-mp="35wnhorbsbce1">
                    NOSE RADIUS
                  </th>
                </> : null}
              <th scope="col" className={th} data-id="element-521" data-mp="310ozxmkyosml">
                DESCRIPTION
              </th>
              {showCategory ? <th scope="col" className={`${th} w-[200px]`} data-id="element-522" data-mp="3tmhsz4gggsw6">
                  CATEGORY
                </th> : null}
            </tr>
          </thead>
          <tbody data-id="element-523" data-mp="3ou6ve896tj6s">
            {rows.map(row => <tr key={row.part} className="border-t border-rule" data-id="element-524" data-mp="3jw5bxm7unhus">
                <th scope="row" className={`${td} whitespace-nowrap text-left font-mono text-[13.5px] font-medium text-navy`} data-id="element-525" data-mp="l6y40hmthwmx">
                  {row.part}
                </th>
                {showSpecs ? <>
                    <td className={`${td} font-mono text-[13px] text-graphite`} data-id="element-526" data-mp="14bth98qjcjal">
                      {row.grade}
                    </td>
                    <td className={`${td} rp-tabular font-mono text-[13px] text-graphite`} data-id="element-527" data-mp="qjd9xvqlpz3v">
                      {row.radius}
                    </td>
                  </> : null}
                <td className={`${td} text-[14.5px] leading-relaxed text-graphite/90`} data-id="element-528" data-mp="gobl7108mz1t">
                  {row.description}
                </td>
                {showCategory ? <td className={td} data-id="element-529" data-mp="7n50efqk322r">
                    <Link to={categoryMeta[row.category].href} data-analytics="product-category-click" data-analytics-label={categoryMeta[row.category].label} className="text-[14px] font-medium text-navy underline decoration-copper underline-offset-4 hover:text-copper" data-id="element-530" data-mp="bn5qwyqxj3q6">
                      {categoryMeta[row.category].label}
                    </Link>
                  </td> : null}
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Below md: stacked records */}
      <ul aria-label={caption} className="space-y-3 md:hidden" data-id="element-531" data-mp="3vi27z8bhpuet">
        {rows.map(row => <li key={row.part} className="border border-rule bg-white p-4" data-id="element-532" data-mp="e1augv551boo">
            <p className="font-mono text-[14.5px] font-medium text-navy" data-id="element-533" data-mp="92pwz3h9t63x">
              {row.part}
            </p>
            {showSpecs ? <p className="rp-tabular mt-1 font-mono text-[12px] tracking-[0.04em] text-graphite/75" data-id="element-534" data-mp="n1fps6x24jmh">
                Grade {row.grade} · Nose radius {row.radius}
              </p> : null}
            <p className="mt-2 text-[14.5px] leading-relaxed text-graphite/90" data-id="element-535" data-mp="2oun6nksbj9ah">
              {row.description}
            </p>
            {showCategory ? <Link to={categoryMeta[row.category].href} data-analytics="product-category-click" data-analytics-label={categoryMeta[row.category].label} className="mt-2 inline-flex min-h-[40px] items-center text-[13.5px] font-medium text-navy underline decoration-copper underline-offset-4" data-id="element-536" data-mp="2m9pi0xbnb5if">
                {categoryMeta[row.category].label}
              </Link> : null}
          </li>)}
      </ul>
    </div>;
}